import { render, staticRenderFns } from "./AddUserModal.vue?vue&type=template&id=a4712a96&scoped=true"
import script from "./AddUserModal.vue?vue&type=script&lang=js"
export * from "./AddUserModal.vue?vue&type=script&lang=js"
import style0 from "./AddUserModal.vue?vue&type=style&index=0&id=a4712a96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4712a96",
  null
  
)

export default component.exports